module.exports = __webpack_public_path__ + "img/LF007-05.6f172b15.jpg";